<template>
  <Section>
    <template #header>
      <div class="mr-auto" v-if="request.source_type == 'from_account'">
        <strong style="color:black">Claimed Leads</strong> (sent by {{ request.user.display_name }})
      </div>
      <div class="mr-auto" v-else>
        <strong style="color:black">Claimed Leads</strong>
      </div>
      <v-btn 
        v-if="request.referrable && !request.is_complete"
        x-small color="primary"
        @click="addClick(request.customer_request_id)"
      >
        Add New
      </v-btn>
    </template>

    <table v-if="request.referrals.length > 0" class="referrals" style="overflow-x: auto;">
      <thead class="grey--text font-weight-bold text--darken-2">
      <tr>
        <td class="lmost">Date</td>
        <td>Pro</td>
        <td>Type</td>
      </tr>
      </thead>
      <tr v-for="referral in request.referrals" :key="referral.referral_id">
        <td class="lmost">{{ $formatters.formatDate(new Date(referral.referral_date)) }}</td>
        <td>
          <router-link 
            v-if="referral.system_status == 'refunded'"
            class="red--text"
            :to="{ name: 'pros/show', params: { pro_id: referral.pro.pro_id } }"
          >
            {{ referral.pro.business_name }}
          </router-link>

          <router-link v-else :to="{ name: 'pros/show', params: { pro_id: referral.pro.pro_id } }">
            {{ referral.pro.business_name }}
          </router-link>
          <span v-if="referral.new" class="font-italic"> - New</span> 
        </td>
        <td>
          {{ referral.referral_type }}
        </td>
      </tr>
    </table>
    <div v-if="request.sent_in_net || request.sent_out_of_net"
      class="text-center font-italic pt-2"
      style="font-size: 12px;"
    >
      sent to
      <span v-if="request.sent_in_net">{{ request.sent_in_net }} current</span>
      <span v-if="request.sent_in_net && request.sent_out_of_net"> and </span>
      <span v-if="request.sent_out_of_net">{{ request.sent_out_of_net }} potential new</span>
      partner(s)<br>
    </div>
    <div
      class="text-center font-italic mt-2"
      style="font-size: 12px;"
    >
      Red links are refunded referrals...
    </div>  
    <div v-if="request.referrals.length > 3"
      class="text-center font-italic pt-2"
      style="font-size: 12px;"
    >
      Good job! {{ request.referrals.length }} pros claimed this lead.
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  
  export default {
    name: 'LeadsSection',

    components: { Section },

    props: {
      request: { type: Object, required: true, },
    },

    methods: {
      async addClick() {
        this.$router.push({ name: 'leads/choose' })
      }
    },
  }
</script>